export function getFileKindLabel(mimeType: string): string {
  if (mimeType.startsWith("image/")) return "Image";
  if (mimeType.startsWith("video/")) return "Video";
  if (mimeType.startsWith("audio/")) return "Audio";
  if (mimeType.includes("pdf")) return "PDF Document";
  if (mimeType.includes("word") || mimeType.includes("document"))
    return "Word Document";
  if (mimeType.includes("excel") || mimeType.includes("spreadsheet"))
    return "Spreadsheet";
  if (mimeType.includes("powerpoint") || mimeType.includes("presentation"))
    return "Presentation";
  if (mimeType.includes("zip") || mimeType.includes("compressed"))
    return "Archive";
  return "File";
}
